var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-choice-container"},[_c('div',{staticClass:"tree-choice-content"},_vm._l((_vm.treeData),function(node){return _c('div',{key:node[_vm.props.value],class:{
        'tree-choice': true,
        'current': _vm.chooseList.includes(node[_vm.props.value])
      },on:{"click":function($event){$event.stopPropagation();return _vm.chooseNode(node)}}},[_c('node-content',{attrs:{"node":node}})],1)}),0),(_vm.children && _vm.children.length)?[_c('tree-node',{attrs:{"props":_vm.props,"treeData":_vm.children,"chooseList":_vm.chooseList}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }